import moment from 'moment';
import { EntryCardStyled } from '../styles/EntryCardStyles';
import { getTypeLabel, isEntryReadByUser } from '../utils/tableroGestionUtils';
import { getTypeIcon } from '../utils/trainingViewUtils';

const EntryCard = ({ entry, currentUserId, onSelect }) => {
  const isRead = isEntryReadByUser(entry, currentUserId);
  const entryDate = entry.entry_date
    ? moment(entry.entry_date).format('DD/MM/YYYY')
    : entry.createdAt
    ? moment(entry.createdAt).format('DD/MM/YYYY')
    : 'N/A';

  return (
    <EntryCardStyled onClick={() => onSelect(entry)}>
      <div className={`card-header type-${entry.type}`}>
        <i className={`type-icon ${getTypeIcon(entry.type)}`}></i>
        {isRead ? (
          <div className="read-badge">
            <i className="fa-solid fa-check"></i>
            <span>Completado</span>
          </div>
        ) : (
          <div className="unread-indicator" title="No completado"></div>
        )}
      </div>
      <div className="card-content">
        <h4>{entry.title}</h4>
        <div className="card-meta">
          <div className="meta-item">
            <i className="fa-solid fa-calendar"></i>
            <span>{entryDate}</span>
          </div>
        </div>
        <span className="type-badge">{getTypeLabel(entry.type)}</span>
      </div>
    </EntryCardStyled>
  );
};

export default EntryCard;
